import client from './api-client';

export const getConfiguracionForm = async(query) => {
    
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDetallesConcepto = async(query) => {
    
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postecepcionar = async(data) => {
    
    try {
        
        const response = await client.post('caso/recepcionar',data);
        if (response.status === 200 && response.data.code === 1) {
            return {
                respuestaProcesar: response.data
            }
        } else {
            return {
                respuestaProcesar: response.data
            }
        }

    } catch(error){
        throw error;
    }
}
export const getResponsablePreAsignado = async(query) => {
    
    try {
        
        const response = await client.get(`responsables/automatico?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                responsable: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
